// extracted by mini-css-extract-plugin
module.exports = {"mutedGray":"#9b9b9b","breadcrumbs":"style-module--breadcrumbs--3hGMa","trenner":"style-module--trenner--tV3oO"};